import { ChangeUserRoleResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class PostChangeUserRole extends BaseAdapter<ChangeUserRoleResponse> implements AdapterInterface {
  rawResponse: ChangeUserRoleResponse;

  async adaptResponse(data: { targetUserEmail: string; newRoleName: string }): Promise<{ email: string; newRoleName: string }> {
    await this.fetchApiResponse('/api/change-user-role', HTTPMethod.Post, {
      target_user_email: data.targetUserEmail,
      new_role_name: data.newRoleName,
    });
    return {
      email: this.rawResponse.email,
      newRoleName: this.rawResponse.new_role_name,
    };
  }
}
